<template>
  <div class="login-page">
    <div>
      <div class="form">
        <div class="form__image">
          <img class="logo" src="../../../assets/images/hrdesk-logo-dark-beta.png" />
        </div>
        <div class="form__token">
          Please enter the OTP sent to your email. If you don’t see it in your
          inbox, please check your junk folder/spam.
        </div>
        <form>
          <div class="login-form">
            <div class="login-form--email">OTP</div>

            <div class="login-form--input">
              <input type="text" v-model="token" placeholder="Enter OTP" />
            </div>
          </div>

          <div class="login-error">
            <span v-show="successMsg">
              Password changed successfully. Go to
              <routerLink to="/login">Login</routerLink>
            </span>
            <span v-show="networkError">{{ networkError }}</span>
          </div>

          <div class="login-btn">
            <button @click.prevent="verifyEmail" v-show="!load">
              Verify Email
            </button>
            <div v-show="load">
              <WhiteLoader />
            </div>
          </div>

          <div class="flex-container">
            <p>Didn't get a OTP?</p>
            <div class="resendLink">
              <p v-if="resendTimerStarted">
                Resend OTP in <span>{{ timer }}</span>
              </p>
              <a v-else @click.prevent="resendOtp"> Resend Token </a>
            </div>
          </div>
        </form>
      </div>

      <div class="footer-message">
        <p class="footer-message--copyright">© 2024 hrdesk</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "VerifyEmail",
  components: {
    WhiteLoader,
  },
  data() {
    return {
      load: false,
      networkError: null,
      passwordError: false,
      successMsg: false,
      token: "",
      email: "",
      resendTimerStarted: false,
      timer: 60,
      intervalId: null,
    };
  },
  methods: {
    resendOtp() {
      this.$http
        .post(types.RESEND_OTP, {
          email: this.email,
        })
        .then((resp) => {
          this.startResendTimer();
        })
        .catch((error) => {
          console.error;
        });
    },

    startResendTimer() {
      this.resendTimerStarted = true;
      this.intervalId = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          this.stopResendTimer();
        }
      }, 1000);
    },

    stopResendTimer() {
      clearInterval(this.intervalId);
      this.resendTimerStarted = false;
      this.timer = 60;
    },

    verifyEmail() {
      this.passwordError = false;
      this.networkError = false;
      this.successMsg = false;

      if (this.token.trim() === "") {
        this.passwordError = true;
        return;
      }

      this.load = true;

      this.$http
        .post(types.VERIFY_EMAIL, {
          token: this.token.trim(),
          email: this.email,
        })
        .then((resp) => {
          if (resp.data.data.has_onboarded == 1) {
            this.$router.push("/dashboard");
          } else {
            this.$router.push("/setup-payroll");
          }
        })
        .catch((error) => {
          let response = error.response;

          if (response.status === 400) {
            this.networkError = response.data.message;
          }

          this.load = false;
        });
    },
  },
  created() {
    this.email = this.$router.currentRoute.query.email;
  },
  // mounted() {
  //   this.startResendTimer();
  // },
  beforeDestroy() {
    this.stopResendTimer();
  },
};
</script>

<style lang="css" scoped>
.resendLink {
  color: #a8a9a9;
  cursor: pointer;

  span {
    color: #5099de;
  }

  a {
    color: #5099de;
  }

  a:hover {
    color: #1f6eb9;
    background: #f6f6f8;
    padding: 0.5rem;
  }
}

.flex-container {
  display: flex;
}

.login-page {
  background: #fbfafa;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.remember-me {
  display: block;
  width: 50px;
  float: left;
}

.icon-space {
  margin: 1px;
}

.login-page>div {
  max-width: 600px;
  margin: 50px auto;
  padding: 0 10px;
}

.form {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 7.552vw;
  padding-right: 7.552vw;
}

.form__image {
  margin: auto;
  max-width: 183px;
}

.form__token {
  margin-top: 20px;
}

.login-form {
  margin-top: 20px;
  overflow: hidden;
}

.login-form--email {
  width: 100%;
  float: left;
  text-align: left;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.login-form--password {
  width: 40%;
  float: left;
  text-align: left;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.login-form--link {
  width: 60%;
  float: left;
  text-align: right;
  font-size: 14px;
  font-weight: 200;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: right;
}

.login-form--link>a {
  text-decoration: none;
  color: #5099de;
}

.login-form--input {
  max-width: 523px;
  margin: auto;
  height: 40px;
  border: solid 1px #c7c7c7;
  clear: both;
  overflow: hidden;
}

.login-form--input>input {
  height: 40px;
  border: none;
  outline: none;
  padding: 0 5px;
  font-size: 14px;
  font-weight: 200;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.5;
  letter-spacing: normal;
  text-align: left;
  color: #000;
}

.login-form--input>input::placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-form--input>input::-ms-input-placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-form--input>input::-ms-input-placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-error {
  height: 20px;
  margin-top: 10px;
  color: red;
  font-size: 12px;
  font-style: italic;
}

.login-error>p {
  margin: 0;
}

.login-error>span>a {
  text-decoration: underline;
  font-weight: 600;
}

.login-btn {
  margin-top: 1rem;
  margin-bottom: 1.3rem;
}

.login-btn>button {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #5099de;
  height: 40px;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.login-btn>div {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #5099de;
  height: 40px;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.login-checkbox {
  text-align: left;
  overflow: hidden;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: flex-start;
}

.login-checkbox-box {
  width: 20px;
  height: 20px;
  float: left;
  text-align: left;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
}

.login-checkbox-text {
  width: 300px;
  height: 20px;
  float: left;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  color: #000000;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
}

.line-through {
  margin-top: 20px;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #c7c7c7;
  line-height: 0.1em;
  margin: 10px 0 20px;
  color: grey;
}

.line-through span {
  background: #fff;
  padding: 0 10px;
  color: #c7c7c7;
}

.form__google {
  height: 40px;
  border-radius: 2px;
  margin-top: 26px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  border: solid 1px #c7c7c7;
  cursor: pointer;
}

.form__google>div {
  width: 95px;
  margin: auto;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.form__google--image {
  width: 28px;
  float: left;
}

.form__google--name {
  float: right;
  padding-top: 0.26vw;
  width: 60px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
}

.message {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
  padding-bottom: 5px;
}

.message>a {
  color: #bababc;
}

.footer-message {
  text-align: center;
  margin-top: 29px;
}

.footer-message--register {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #777777;
}

.footer-message--register>a {
  color: #5099de;
  text-decoration: none;
}

.footer-message--company {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
}

.footer-message--company>a {
  color: #5099de;
  text-decoration: none;
}

.footer-message--copyright {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
</style>
